/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyUserDto
 */
export interface CompanyUserDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyUserDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyUserDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUserDto
     */
    email: string;
}

/**
 * Check if a given object implements the CompanyUserDto interface.
 */
export function instanceOfCompanyUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function CompanyUserDtoFromJSON(json: any): CompanyUserDto {
    return CompanyUserDtoFromJSONTyped(json, false);
}

export function CompanyUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
    };
}

export function CompanyUserDtoToJSON(value?: CompanyUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'email': value.email,
    };
}

